import { FC } from 'react';
import styled from 'styled-components';

const StyledText = styled.span`
  clip: rect(0, 0, 0, 0);
  clip-path: inset(100%);
  height: 1px;
  width: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
`;

interface AccessibleHiddenTextProps {
  children: React.ReactNode;
}

const AccessibleHiddenText: FC<AccessibleHiddenTextProps> = ({ children }) => {
  return <StyledText>{children}</StyledText>;
};

export default AccessibleHiddenText;
